import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {registerLicense} from '@syncfusion/ej2-base';
// aws
import Amplify from 'aws-amplify';
import amplify from './aws-exports';
Amplify.configure(amplify);
// aws END

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1ednRWQ2JeWEZ1WUQ=');

if (environment.production) {
  enableProdMode();
  if (window) {
  //  window.console.log = () => { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
